import { DocxIcon, NotesAttachmentIcon, NotesImageIcon, PdfIcon } from "icons";
import styles from "./styles.module.scss";
import { UseApiCallV2, UseLazyApiCallV2 } from "hooks";
import { FileUpload } from "../file-upload";
import { useMemo, useState } from "react";
import { ConditionalRenderer } from "components";
import { Spin } from "antd";
import { UploadedFiles } from "../uploaded-files";

export const NoteAttachments = ({
  note_id,
  getFileUuidsFromChild,
  uploading,
  setUploading,
}) => {
  const tabs = [
    {
      title: "All Documents",
      icon: null,
    },
    {
      title: "PDF",
      icon: PdfIcon,
    },
    {
      title: "DOCX",
      icon: DocxIcon,
    },
    {
      title: "Images",
      icon: NotesImageIcon,
    },
  ];
  const [activeTab, setActiveTab] = useState(tabs[0].title);
  const {
    data: noteAttachments,
    isLoading: noteAttachmentsLoading,
    refetch: refetchnoteAttachments,
  } = UseApiCallV2({
    url: "/get_attachments",
    method: "POST",
    skip: !note_id,
    paramsData: {
      note_id,
    },
  });

  const showUploadedSection =
    note_id && noteAttachments?.attachments?.length > 0;

  return (
    <div className={styles.attachmentSection}>
      <FileUpload
        note_id={note_id}
        refetchnoteAttachments={refetchnoteAttachments}
        getFileUuidsFromChild={getFileUuidsFromChild}
        uploading={uploading}
        setUploading={setUploading}
        showUploadedSection={showUploadedSection}
      />
      <ConditionalRenderer condition={showUploadedSection}>
        <UploadedFiles
          files={noteAttachments?.attachments}
          note_id={note_id}
          refetchnoteAttachments={refetchnoteAttachments}
          filesLoading={noteAttachmentsLoading}
        />
      </ConditionalRenderer>
      {/* <div className={styles.uploadedFiles}>
        <Spin spinning={noteAttachmentsLoading}>
          <div className={styles.tabs}>
            {tabs?.map((tab) => (
              <div
                style={{
                  position: "relative",
                  color: activeTab === tab.title ? "#cd2a3f" : "black",
                }}
                className={`${styles.singleTab}`}
                key={tab.title}
                onClick={() => setActiveTab(tab.title)}
              >
                {tab?.icon ? <tab.icon /> : null}
                <div>{tab.title}</div>
                <ConditionalRenderer condition={tab.title === activeTab}>
                  <div className={styles.active} />
                </ConditionalRenderer>
              </div>
            ))}
          </div>
          <div className={styles.separator}></div>

        
        </Spin>
      </div> */}
    </div>
  );
};
